import type {
  TitleVariantConfig,
  TitleVariantDefault,
} from '@/components/Title/Title.types'

export const TITLE_VARIANT_DEFAULT: Record<
  TitleVariantDefault,
  TitleVariantConfig
> = {
  h1: {
    fw: 700,
    mb: 20,
    order: 1,
  },
  h1_big: {
    fw: 700,
    mb: 0,
    order: 1,
    size: 32,
  },
  h1_big_green: {
    c: 'var(--mantine-other-colors-green)',
    fw: 700,
    mb: 0,
    order: 1,
    size: 32,
  },
  h1_extra_big: {
    fw: 700,
    mb: 0,
    order: 1,
    size: 48,
  },
  h1_regular: {
    fw: 400,
    mb: 0,
    order: 1,
  },
  h2: {
    fw: 600,
    mb: 18,
    order: 2,
  },
  h2_small: {
    fw: 700,
    mb: 0,
    order: 2,
    size: 18,
  },
  h3: {
    fw: 500,
    mb: 16,
    order: 3,
    size: 18,
  },
  h4: {
    fw: 600,
    mb: 2,
    order: 4,
  },
  h5: {
    fw: 700,
    mb: 4,
    order: 5,
    size: 18,
  },
}
